// Design tokens used by the shared "onboarding document" building blocks.
// Values mirror the --nav-* variables in navigator_people_v83.html; anything that already exists
// in AdminColors is re-used from there so the palette stays in one place.
import { AdminColors } from '../../../../Admin/constants/adminColors';

export const DocColors = {
  pageBg: AdminColors.bgPage,           // --nav-bg-page
  surface: AdminColors.bgSurface,       // --nav-bg-surface
  blue25: AdminColors.blue25,
  blue50: AdminColors.blue50,
  blue100: '#C6DCFB',                   // --nav-blue-100
  blue200: AdminColors.blue200,
  blue700: AdminColors.blue700,
  blue800: AdminColors.blue800,
  blue900: AdminColors.blue900,
  gray25: AdminColors.gray25,
  green50: '#DDF9DA',                   // --nav-green-50
  green200: '#7ADB74',                  // --nav-green-200
  greenText: '#0C420B',                 // --nav-green-text
  orange75: AdminColors.tagOrange.bg,   // --nav-orange-75
  orange200: '#FF8C09',                 // --nav-orange-200
  gray150: AdminColors.gray150,         // --nav-gray-150 (silver)
  textPrimary: AdminColors.textPrimary,
  textSecondary: AdminColors.textSecondary,
  textMuted: '#666666',                 // --nav-text-muted
  textOnDark: AdminColors.textOnDark,
  inputBorder: '#949494',               // --nav-border-default
  required: AdminColors.red500,         // --nav-red-500
  scrim: 'rgba(0, 0, 0, 0.5)',          // --nav-bg-overlay
  modalShadow: '#005EC0',               // --nav-elevation-03 tint
} as const;
